import * as L from 'leaflet'
import { DEFAULT_LAYER_OPTIONS, LINZ_BASE_MAP_URL, LINZ_KEY, MAPBOX_ACCESS_TOKEN } from './constants'

const createMapboxTileLayer = (styleId: string, zIndex = 1, attribution?: string) => {
  return L.tileLayer(
    `https://api.mapbox.com/styles/v1/national-wells/${styleId}/tiles/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESS_TOKEN}`,
    {
      ...DEFAULT_LAYER_OPTIONS,
      zIndex,
      attribution,
    },
  )
}

/**
 * @returns L.layerGroup containing the LINZ and streets baselayers
 */
export const getBaseLayers = () => {
  const linz = L.tileLayer(`${LINZ_BASE_MAP_URL}?api=${LINZ_KEY}`, {
    ...DEFAULT_LAYER_OPTIONS,
    attribution:
      '<a href="//www.linz.govt.nz/data/linz-data/linz-basemaps/data-attribution">LINZ CC BY 4.0 © Imagery Basemap contributors</a>',
  })

  const streetsCities = createMapboxTileLayer('clxa0sl0c021001pogm4t0rt3')
  return L.layerGroup([linz, streetsCities])
}

const STREET_LAND_PARCEL_LAYER = createMapboxTileLayer('clz8xzt9i004701r13aeaari4')
const GEOLOGICAL_BOUNDARIES_UNITS_LAYER = createMapboxTileLayer(
  'cly2cmwrc006701oe76c4bcqu',
  1,
  '© <a href="https://data.gns.cri.nz/metadata/srv/eng/catalog.search#/metadata/22af54a9-ab42-46f1-ab84-70a57775a67a">GNS Science 2023</a>',
)

export const MAPBOX_LAYERS = Object.freeze({
  townRoads: { name: 'Aerial imagery', layers: getBaseLayers() },
  landStreetParcels: { name: 'Street with land parcels', layers: STREET_LAND_PARCEL_LAYER },
  geologicalBoundariesUnits: { name: 'Geological boundaries & units', layers: GEOLOGICAL_BOUNDARIES_UNITS_LAYER },
})

type Layer = Readonly<keyof typeof MAPBOX_LAYERS>

export const getLayersConfig = () => {
  // Overlays do not exist as they are embedded into the styles for Geological boundaries/units, linz and land parcels layers.
  const overLays = {}
  const layers = Object.keys(MAPBOX_LAYERS).reduce(
    (layers, currentKey) => ({
      ...layers,
      [MAPBOX_LAYERS[currentKey as Layer].name]: MAPBOX_LAYERS[currentKey as Layer].layers,
    }),
    {},
  )

  const layerControl = L.control.layers(layers, overLays, { position: 'bottomright', autoZIndex: false })

  return {
    layers,
    control: layerControl,
    defaultLayers: MAPBOX_LAYERS['townRoads'].layers,
  }
}
